import styles from './RmCardsGroupSeries.module.scss';
import RmCardsTwinGroupContainer from './RmCardsTwinGroupContainer';
import PropTypes from 'prop-types';

const SeriesContainer = (props) => {
    const { cardsDataArray, navigateTo } = props;
    return (
        <div className={styles.seriesContainer}>
            {cardsDataArray.length > 0 &&
                cardsDataArray.map((card, idx) => {
                    return (
                        <RmCardsTwinGroupContainer
                            key={`RmTwinGroupContainer-${card.subTitleOne}-${card.subTitleTwo}-${idx}`}
                            titleOne={card.titleOne}
                            titleTwo={card.titleTwo}
                            subTitleOne={card.subTitleOne}
                            subTitleTwo={card.subTitleTwo}
                            upperRightContentOne={
                                card.upperRightContentOne &&
                                card.upperRightContentOne
                            }
                            upperRightContentTwo={
                                card.upperRightContentTwo &&
                                card.upperRightContentTwo
                            }
                            footerOne={card.footerOne}
                            footerTwo={card.footerTwo}
                            groupOneData={card.groupOneData}
                            groupTwoData={card.groupTwoData}
                            groupOneDataType={card.groupOneDataType}
                            groupTwoDataType={card.groupTwoDataType}
                            groupOneTooltipType={card.groupOneTooltipType}
                            groupTwoTooltipType={card.groupTwoTooltipType}
                            isBottomGroup={card.isBottomGroup}
                            navigateTo={navigateTo}
                        />
                    );
                })}
        </div>
    );
};

SeriesContainer.propTypes = {
    cardsDataArray: PropTypes.arrayOf(
        PropTypes.shape({
            titleOne: PropTypes.string.isRequired,
            titleTwo: PropTypes.string.isRequired,
            subTitleOne: PropTypes.string.isRequired,
            subTitleTwo: PropTypes.string.isRequired,
            upperRightContentOne: PropTypes.element,
            upperRightContentTwo: PropTypes.element,
            footerOne: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
                .isRequired,
            footerTwo: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
                .isRequired,
            groupOneData: PropTypes.any,
            groupTwoData: PropTypes.any,
            groupOneDataType: PropTypes.oneOf([
                'default',
                'topFiveRms',
                'topFiveEmergingModerateRm',
                'topFiveEmergingMajorRm',
                'topFiveRmsSpike',
                'alerts'
            ]).isRequired,
            groupTwoDataType: PropTypes.oneOf([
                'default',
                'topFiveRms',
                'topFiveEmergingModerateRm',
                'topFiveEmergingMajorRm',
                'topFiveRmsSpike',
                'alerts'
            ]).isRequired,
            groupOneTooltipType: PropTypes.oneOf([
                'default',
                'scoreDecomposition',
                'trendAnalysis'
            ]),
            groupTwoTooltipType: PropTypes.oneOf([
                'default',
                'scoreDecomposition',
                'trendAnalysis'
            ]),
            isBottomGroup: PropTypes.bool
        })
    ),
    navigateTo: PropTypes.func
};

export default SeriesContainer;
